import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';

App[$.FILENAME] = 'src/client/App.svelte';

import * as $ from 'svelte/internal/client';
import { browserRouter } from "./route.ts";
import { rpcSource } from "./rpc.ts";
import StudyRoot from "./StudyRoot.svelte";

var root = $.add_locations(
	$.from_html(
		`

<main class="app svelte-2bje46rx1i8e2">
  <!>
</main>

`,
		1
	),
	App[$.FILENAME],
	[[7, 0]]
);

export default function App($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, false, App);

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root();
	var main = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(main));

	$.add_svelte_meta(
		() => StudyRoot(node, {
			get source() {
				return rpcSource;
			},

			get router() {
				return browserRouter;
			}
		}),
		'component',
		App,
		8,
		2,
		{ componentTag: 'StudyRoot' }
	);

	$.next();
	$.reset(main);
	$.next();
	$.append($$anchor, fragment);

	return $.pop($$exports);
}
import "bun-svelte:App.svelte-4q8gn9iimv3j-style.css";